import Link from "next/link";
import React from "react";
import { AiOutlineLeft } from "react-icons/ai";

import { cn } from "utils/cn";

const InnerNav = ({
  title,
  url = "",
  children,
  size = "24",
  lineHeight = "1.5",
  className,
  onClick,
}: {
  title: string;
  url?: string;
  children?: React.ReactNode;
  size?: "20" | "24";
  lineHeight?: string;
  className?: string;
  onClick?: () => void;
}) => {
  return (
    <div className={cn(`my-4 flex max-h-[30px] flex-row items-start justify-between ${className}`)}>
      {url ? (
        <Link
          href={url}
          onClick={(e) => {
            if (onClick) {
              e.preventDefault();
              onClick();
            }
          }}
        >
          <div className="flex items-center gap-4">
            <AiOutlineLeft />
            <span className={`text-${size}px text-black`} style={{ lineHeight }}>
              {title}
            </span>
          </div>
        </Link>
      ) : (
        <span className={`text-${size}px text-black`} style={{ lineHeight }}>
          {title}
        </span>
      )}
      {children}
    </div>
  );
};

export default InnerNav;
